import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';

export const SubsidyNavigation = ({ prevScheme, nextScheme, subsidyData }) => (
  <section className="py-8 bg-white border-t border-slate-100">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="flex justify-between">
        {prevScheme ? (
          <Link
            to={`/subsidies/${prevScheme}`}
            className="flex items-center gap-2 text-[#64748b] hover:text-[#3b5998] transition-colors"
          >
            <ArrowLeft size={18} />
            <span>{subsidyData[prevScheme].name}</span>
          </Link>
        ) : <div />}
        {nextScheme && (
          <Link
            to={`/subsidies/${nextScheme}`}
            className="flex items-center gap-2 text-[#64748b] hover:text-[#3b5998] transition-colors"
          >
            <span>{subsidyData[nextScheme].name}</span>
            <ArrowRight size={18} />
          </Link>
        )}
      </div>
    </div>
  </section>
);
